<template>
    <div class="search" :style="{'--theme-color': themeColor}">
      <el-input ref="elInput" @click.stop :placeholder="info.info.placeholder" @focus="inputFocus" @keyup="goSearch" v-model="searchText" :style="{width: info.info.width === 'custom' ? `${info.info.customSize}px` : '', '--el-input-border-color': themeColor }">
        <template #prefix>
          <div class="el-input-prev">
            <!-- <i class="el-icon-search"></i> -->
            <el-icon>
              <Search />
            </el-icon>
          </div>
        </template>
        <template #suffix>
          <div class="el-input-suff">
            <div class="suff-button" @click="goSearch">
              {{ info.info.btnText || '搜索' }}
            </div>
          </div>
        </template>
      </el-input>
      <teleport to="body">
        <div class="history-list" ref="historyList" :style="{ '--theme-color': themeColor }" v-show="isAppen && historyList.length !== 0">
          <div class="divisionLine"></div>
          <div class="history-list-item" @click.stop="goSearch({}, item)" v-for="(item, index) in historyList" :key="index">
            <span>{{ item }}</span>
            <i @click.stop="goDel(index)" class="iconfont icon-shanchu3"></i>
          </div>
        </div>
      </teleport>
    </div>
</template>

<script>
import search from './search'
export default {
  // 组件名称
  name: 'bigsearchComp',
  mixins: [search],
  data() {
    return {
    }
  },
  methods: {
    goSearch(e, name) {
      if (e.keyCode === 13 || e.keyCode === undefined) { 
        const text = name || this.searchText
        if (text) {
          this.historyList.unshift(text)
          const list = new Set(this.historyList)
          this.historyList = [...list]
          localStorage.setItem('history-bigsearch', JSON.stringify(this.historyList))
          this.isAppen = false
        }
        if (name || name === 0) this.searchText = name
        this.search(e, name)
      }
    },
    goDel(idx) {
      this.historyList.splice(idx, 1)
      localStorage.setItem('history-bigsearch', JSON.stringify(this.historyList))
    },
    inputFocus() {
        this.initHittory(12)
        this.isAppen = true
    },
  },
  mounted() {
    this.init('bigsearch')
  },
}
</script>

<style scoped lang="scss">
$themeColor: var(--theme-color);
::v-deep.search {
  height: 160px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  .el-input {
    height: 60px;
    box-sizing: border-box;
    font-size: 16px;
    .el-input__inner {
      padding-left: 74px;
      height: 60px;
      box-sizing: border-box;
      line-height: 60px;
    }
    .el-input__prefix {
      left: 0;
      .el-input-prev {
        height: 100%;
        display: flex;
        align-items: center;
        padding-left: 30px;
        color: $themeColor;
        .el-icon-search {
          font-size: 24px;
        }
      }
    }
    .el-input__suffix {
      right: 0;
      .el-input__suffix-inner {
        height: 100%;
        .el-input-suff {
          display: flex;
          align-items: center;
          height: 100%;
          padding-right: 16px;
          cursor: pointer;
          .suff-button {
            padding: 8px 45px;
            background-color: $themeColor;
            color: #fff;
            border-radius: 4px;
          }
        }
      }
    }
  }
}
</style>

<style lang="scss">
.history-list {
  $themeColor: var(--theme-color);
  position: absolute;
  min-height: 100px;
  width: 100%;
  border-top: none;
  padding: 0 20px;
  box-sizing: border-box;
  background-color: #fff;
  border-radius: 0 0 4px 4px;
  border: solid 1px $themeColor;
  border-top: none;
  .divisionLine {
    width: 100%;
    height: 1px;
    background-color: #D1D4DC;
    margin: 12px 0;
  }
  .history-list-item {
    width: 100%;
    padding: 0 32px;
    box-sizing: border-box;
    height: 34px;
    color: #333333;
    font-weight: 400;
    font-size: 16px;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    cursor: pointer;
    .icon-shanchu3 {
      font-size: 14px;
      color: #333333;
      display: none;
    }
    span {
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    &:hover {
      color: $themeColor;
      .icon-shanchu3 {
        color: $themeColor;
        display: block;
      }
    }
  }
}
</style>
